var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 40",
  x: "0px",
  y: "0px",
  width: 32,
  height: 32
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.586 1.612c-0.145-0-0.285 0.052-0.397 0.164-0.224 0.224-0.224 0.568 0 0.792l12.147 12.171c0.691 0.692 0.688 1.831-0.004 2.522l-12.143 12.171c-0.224 0.224-0.224 0.568 0 0.792v0.002h0.002c0.109 0.11 0.248 0.162 0.393 0.162h0.006c0.141-0.001 0.28-0.052 0.392-0.164l12.147-12.169c1.136-1.136 1.135-2.974 0-4.108l-12.147-12.171c-0.111-0.111-0.25-0.163-0.395-0.164z"
})));
export default SvgChevronRight;